import { ForwardedRef, useRef, useLayoutEffect } from 'react'

export const useForwardedRef = <T>(ref: ForwardedRef<T>) => {
  const innerRef = useRef<T>(null)

  useLayoutEffect(() => {
    if (!ref || !innerRef.current) {
      return
    }

    if (typeof ref === 'function') {
      ref(innerRef.current)
      return
    }

    ref.current = innerRef.current
  }, [ref])

  return innerRef
}
